import { Identified, PartialMaybe, Timestamped, Tracked } from '../../../abstract/_';
import { AbstractCollection } from '../../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Trackable } from '../../../abstract/Document';
import { Lead } from '../Leads';
import { type ILeadNote } from './Notes.types';
import { type WithFieldValue } from 'firebase/firestore';

@Identifiable
@Timestampable
@Trackable
export class Note extends AbstractDocument<ILeadNote> {
  readonly collections = {};

  /**
   * Returns the parent Lead of this Note
   */
  get lead() {
    return this.reference.parent.parent!.id;
  }
}

export class Notes extends AbstractCollection<Note, ILeadNote> {
  static path = 'notes';

  constructor(document: Lead) {
    super(document.collection(Notes.path), Note);
  }

  /**
   * Returns the parent Lead of this Notes collection
   */
  get lead() {
    return this.reference.parent!.id;
  }

  /**
   * Creates a new note
   *
   * @param data Object containing note creation parameters
   */
  async create(data: WithFieldValue<PartialMaybe<ILeadNote, Identified & Timestamped & Tracked>>): Promise<Note> {
    return await this.push().create(data as ILeadNote & Tracked);
  }
}
